import {recovery} from './http_service';

export function sendNotification(email) {
    return recovery().post('/notification/send-notification', {email});
}